import React, { useState, useEffect } from "react";
import "./Footer.css";
import { Button, Image, Stack } from "react-bootstrap";
import { chunk, map } from "lodash";
import { RiCopyrightLine } from "react-icons/ri";
import { MdKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";
import { useNavigate } from "react-router-dom";

export const Footer = () => {
  const navigate = useNavigate();
  const holidays = [
    { id: 1, title: "UAE", href: "/destination/uae" },
    { id: 2, title: "Kenya", href: "/destination/kenya" },
    { id: 3, title: "Tanzania", href: "/destination/tanzania" },
    { id: 4, title: "Zambia", href: "/destination/zambia" },
    { id: 5, title: "South Africa", href: "/destination/south-africa" },
    { id: 6, title: "Zimbabwe", href: "/destination/zimbabwe" },
    { id: 7, title: "Uganda", href: "/destination/uganda" },
    { id: 8, title: "India", href: "/destination/india" },
    { id: 9, title: "Qatar", href: "/destination/qatar" },
    // { id: 10, title: "Rwanda", href: "/destination/rwanda" },

    
    { id: 11, title: "Malaysia", href: "/destination/malaysia" },
    { id: 12, title: "Singapore", href: "/destination/singapore" },
  ];

  const bestToDo = [
    { id: 1, title: "Adventure", href: "/experiences/adventure" },
    { id: 2, title: "Conservation", href: "/experiences/conservations" },
    { id: 3, title: "Safaris", href: "/experiences/safaris" },
    { id: 4, title: "Luxury travel", href: "/experiences/luxury-travel" },
    { id: 5, title: "Camps", href: "/experiences/camps" },
    { id: 6, title: "Art & Culture", href: "/experiences/art-culture" },
    { id: 7, title: "Food & Wine", href: "/experiences/food-wine" },
    { id: 8, title: "Relaxation", href: "/experiences/relaxation" },
  ];

  const menuItems = [
    { id: 1, title: "ABOUT US", href: "/about-us" },
    { id: 2, title: "B2B AGENTS", href: "/b2b-agents" },
    { id: 3, title: "EXPERIENCES", href: "/experiences" },
    { id: 4, title: "Medical Tourism", href: "/medical" },
    { id: 5, title: "BLOG", href: "/blog" },
  ];

  const settings = {
    infinite: true,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: false,
    variableWidth: true,
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          variableWidth: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          variableWidth: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          variableWidth: true,
        },
      },
    ],
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 576);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isMobileToDo, setIsMobileToDo] = useState(window.innerWidth <= 576);
  const [isOpenToDo, setIsOpenToDo] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileToDo(window.innerWidth <= 576);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isMobileNewsletter, setIsMobileNewsletter] = useState(
    window.innerWidth <= 768,
  );
  const [isOpenNewsletter, setIsOpenNewsletter] = useState(true); // Open by default

  useEffect(() => {
    const handleResize = () => {
      setIsMobileNewsletter(window.innerWidth <= 576);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="footer standard-padding">
        <Stack className="footer-container">
          <Stack className="footer-sec1 pe-md-5 ps-0">
            <a href="/" style={{ textDecoration: "none" }}>
              <Image
                style={{ marginBottom: "35px" }}
                src="/assets/dmc-logo-footer.svg"
                className="footerDmclogo"
                alt="image"
              />
            </a>
            {/* <Image style={{ marginBottom: "20px" }} src="/assets/DMC-white-01.png" className="footerDmclogo" alt="image" /> */}
            <p className="pe-4" style={{ color: "#FFFFFFE5" }}>
              Blueberry DMC is an award-winning luxury destination management
              company, with an outstanding history and culture, who have been
              offering tailor-made holidays for discerning travelers since
              2013.{" "}
            </p>

            <div className="footer-social-icons">
              <a
                href="https://www.facebook.com/blueberrydmc"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  src="/assets/facebook.svg"
                  alt="facebook"
                  className="social-icon"
                />
              </a>

              <a
                href="https://www.instagram.com/blueberry_dmc/"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  src="/assets/insta.svg"
                  alt="instagram"
                  className="social-icon"
                />
              </a>

              <a
                href="https://www.linkedin.com/company/blueberry-dmc/?viewAsMember=true"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  src="/assets/linkedin.svg"
                  alt="linkedin"
                  className="social-icon"
                />
              </a>
            </div>
          </Stack>

          <Stack className="footer-sec1">
            <div
              className="footer-heading-container"
              onClick={() => isMobile && setIsOpen(!isOpen)}
            >
              <h5 className="footer-heading">COUNTRIES TO EXPLORE</h5>
              {isMobile && (
                <span className="dropdown-arrow">
                  {isOpen ? (
                    <MdOutlineKeyboardArrowUp size={24} />
                  ) : (
                    <MdKeyboardArrowDown size={24} />
                  )}
                </span>
              )}
            </div>

            {/* Show links only when dropdown is open on mobile */}
            {(isOpen || !isMobile) && (
              <div className="footer-links holiday-footer-links">
                {map(holidays, (ho) => (
                  <p
                    key={ho.id}
                    className="footer-holiday-link"
                    onClick={() => navigate(ho.href)}
                  >
                    {ho.title}
                  </p>
                ))}
              </div>
            )}
          </Stack>
          <Stack className="footer-sec1">
            <div
              className="footer-heading-container"
              onClick={() => isMobileToDo && setIsOpenToDo(!isOpenToDo)}
            >
              <h5 className="footer-heading">EXPERIENCES</h5>
              {isMobileToDo && (
                <span className="dropdown-arrow">
                  {isOpenToDo ? (
                    <MdOutlineKeyboardArrowUp size={24} />
                  ) : (
                    <MdKeyboardArrowDown size={24} />
                  )}
                </span>
              )}
            </div>

            {/* Show links only when dropdown is open on mobile */}
            {(isOpenToDo || !isMobileToDo) && (
              <div className="footer-links holiday-footer-links">
                {map(bestToDo, (ho) => (
                  <p
                    key={ho.id}
                    className="footer-holiday-link"
                    onClick={() => navigate(ho.href)}
                  >
                    {ho.title}
                  </p>
                ))}
              </div>
            )}
          </Stack>

          <Stack className="footer-sec1">
            <div
              className="footer-heading-container"
              onClick={() =>
                isMobileNewsletter && setIsOpenNewsletter(!isOpenNewsletter)
              }
            >
              {/* <h5 className="footer-heading">MENU ITEMS</h5> */}
              {/* {isMobileNewsletter && <span className="dropdown-arrow">{isOpen ? <MdOutlineKeyboardArrowUp size={24} /> : <MdKeyboardArrowDown size={24} />}</span>} */}
            </div>

            {/* Show links only when dropdown is open on mobile */}
            {(isOpenNewsletter || !isMobileNewsletter) && (
              <div className="footer-links holiday-footer-links">
                {map(menuItems, (ho) => (
                  <p
                    key={ho.id}
                    className="footer-heading"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(ho.href)}
                  >
                    {ho.title}
                  </p>
                ))}
              </div>
            )}
          </Stack>
        </Stack>
      </div>
      {/* <div className="footer-slider">
                <Slider {...settings}>
                    {map(partners, (part) => (
                        <div key={part.id} className="footer-slider-div">
                            <Image src={part.img} className="partner-image" />
                        </div>
                    ))}
                </Slider>
            </div> */}
      <div className="footer-claims">
        <Stack
          direction="horizontal"
          className="d-flex justify-content-between flex-md-row flex-column"
        >
          <p className="mb-0">
            <RiCopyrightLine /> Copyright 2026, All Rights Reserved by DMC
          </p>
          <p className="mb-0">Unit of Blueberry Group</p>
          <div className="d-flex">
            <p
              style={{ cursor: "pointer" }}
              className="mb-0"
              onClick={() => navigate("/terms-conditions")}
            >
              Term & Conditions
            </p>
            <p
              style={{ cursor: "pointer", marginLeft: "10px" }}
              className="mb-0"
              onClick={() => navigate("/privacy-policy")}
            >
              Privacy Policy
            </p>
          </div>
        </Stack>
      </div>
    </>
  );
};
